const Department = () => import("@/page/department");
const departmain = () => import("@/page/departments/main");
const Editor = () => import("@/page/departments/Editor");//编辑
const DepartDetail = () => import("@/page/departments/DepartDetail");//详情

export default {
  path: "/Department", 
  component: Department,
  children:[ {
      path: 'departmain',
      name: 'departmain',
      component:departmain,
    },{
      path: 'Editor',
      name: 'Editor',
      component:Editor,
    },{
      path: 'DepartDetail',
      name: 'DepartDetail',
      component:DepartDetail,
    }]

};


// WEBPACK FOOTER //
// ./src/router/department.js